import { Routes, Route, Outlet } from 'react-router-dom';
import { UniformMgmtProvider } from '../context/uniformMgmtContext';

import MastersDashboard from '../masters/MastersDashboard';
import UniformItemDetail from '../masters/items/UniformItemDetail';
import WarehouseDetail from '../masters/warehouses/WarehouseDetail';

import StockReceiving from '../inventory/receiving/StockReceiving';
import TransferList from '../inventory/transfers/TransferList';
import StockTakeList from '../inventory/stockTake/StockTakeList';
import StockTakeDetail from '../inventory/stockTake/StockTakeDetail';

import IssuanceList from '../issuance/issuanceList/IssuanceList';
import IssuanceDetail from '../issuance/issuanceDetail/IssuanceDetail';
import BulkIssuance from '../issuance/bulkIssuance/BulkIssuance';
import RejectionReview from '../issuance/rejectionReview/RejectionReview';

import EmployeeUniformCard from '../employee/uniformCard/EmployeeUniformCard';
import MyUniformsList from '../employee/myUniforms/MyUniformsList';

import ReportsDashboard from '../reports/ReportsDashboard';

function UniformMgmtRouter() {
  return (
    <UniformMgmtProvider>
      <Routes>
        <Route path="/" element={<Outlet />}>
          <Route index element={<MastersDashboard />} />
          <Route path="items/:id" element={<UniformItemDetail />} />
          <Route path="warehouses/:id" element={<WarehouseDetail />} />

          <Route path="stock-receiving" element={<StockReceiving />} />
          <Route path="transfers" element={<TransferList />} />
          <Route path="stock-take" element={<StockTakeList />} />
          <Route path="stock-take/:id" element={<StockTakeDetail />} />

          <Route path="issuance" element={<IssuanceList />} />
          <Route path="issuance/:id" element={<IssuanceDetail />} />
          <Route path="bulk-issuance" element={<BulkIssuance />} />
          <Route path="rejection-review" element={<RejectionReview />} />

          <Route path="employee-card/:userId" element={<EmployeeUniformCard />} />
          <Route path="my-uniforms" element={<MyUniformsList />} />

          <Route path="reports" element={<ReportsDashboard />} />
        </Route>
      </Routes>
    </UniformMgmtProvider>
  );
}

export default UniformMgmtRouter;
